// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__5AwIT","addWidgetButton":"Header_addWidgetButton__2gYLU","dashboardTabs":"Header_dashboardTabs__2elL6","active":"Header_active__2sYSM"};